import React from 'react';
const styledComponentsPlugin = (element, plugins, app) => {
    if (plugins === null || plugins === void 0 ? void 0 : plugins.find((plugin) => plugin.name === 'styled-components')) {
        try {
            const { StyleSheetManager } = require('styled-components');
            const insertionPoint = document.createElement('span');
            insertionPoint.id = 'direflow_styled-components-styles';
            return [React.createElement(StyleSheetManager, { target: insertionPoint }, app), insertionPoint];
        }
        catch (error) {
            console.error('Could not load styled-components. Did you remember to install styled-components?');
        }
    }
};
export default styledComponentsPlugin;
